import React from "react";
import { BrowserRouter, Route, Routes} from "react-router-dom";
import { AuthProvider } from "./contexts/AuthProvider";

import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import Home from "./pages/Home"
import Question from "./pages/Question";

function App() {
  return (
    <div>
      <AuthProvider>
        <BrowserRouter>
            <Routes>
              <Route index element={<Home/>} />
              <Route path="/auth" element={<Auth/>} />
              <Route path="/dashboard" element={<Dashboard/>} />
              <Route path="/topic/:topicID/subtopic/:subtopicID/question/:questionID" element={<Question/>}/>
            </Routes>
        </BrowserRouter>
      </AuthProvider>
      </div>
  );
}

export default App;